import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs: [string, string][] = [['How do I receive the materials?', 'Instantly. After purchase you get immediate digital access to download all 10 volumes and the five bonuses.'], ['Do I need to be fluent in Spanish?', 'No. Every rule, instruction and answer key is written in plain English, so you can teach each unit with confidence even as a non-native speaker.'], ['What ages and grades does it cover?', 'Spanish Ready covers Grade K through Year 12, with one complete volume per school year and an A1 → B2 progression.'], ['Are the lessons print or digital?', 'Both. Print the full volumes, print individual activities, or teach directly from a screen.'], ['What formats are the files in?', 'High-quality PDFs, ready to print or use digitally on any device.'], ['Can I use it across a whole department?', 'Yes. The volumes are structured so a whole languages department can follow the same progression across year groups.'], ['Is there a refund policy?', 'Yes. You are covered by a 30-day, no-questions-asked money-back guarantee. If Spanish Ready is not right for you, request a full refund and keep the bonuses.']];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-47" data-mp="2af726eadsw2m">
      <Reveal className="mx-auto max-w-3xl" data-id="element-48" data-mp="2ah07nq99da91">
        <div className="mb-12 text-center" data-id="element-49" data-mp="2oeou32iz4pg7">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-50" data-mp="2occciqh4oh3o">
            GOOD TO KNOW
          </p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-51" data-mp="u05qewmp4fwl">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-3" data-id="element-52" data-mp="p2mbdui6bz3l">
          {faqs.map(([question, answer], index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-blue/[0.06] bg-brand-alt" data-id="element-53" data-mp="2u36vzv38ag5t" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold text-brand-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange" data-id="element-54" data-mp="333lkf3bhobdj">
                  <span data-id="element-55" data-mp="3mtf4ev7ypm77">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-56" data-mp="3qu8xs446bt7h" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-57" data-mp="1k5qbuhrr8zzd" />}
                </button>
                <AnimatePresence initial={false} data-id="element-58" data-mp="1b50nu08qkdw7">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-59" data-mp="165nyn8ue6uqg">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-60" data-mp="1p407sulb04m1">
                        {answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}